export default {
    ObtenerDocumentosAdjuntos(vm, datos) {

        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/ObtenerDocumentosAdjuntos`, datos).then(response => response.data)
    },
    TotalCheck(vm, datos) {

        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/ChecarTotal`, datos).then(response => response.data);
    },
    ObtenerDireccion(vm, datos) {

        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ObtenerDireccion`, datos).then(response => response.data);
    },
    AlmacenarVisitas(vm, datos) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/AlmacenarVisitas`, datos).then(response => response.data);
    },
    ObtenerListaDocs(vm, datos) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/DocumentosList`,datos).then(response => response.data);
        
    },
    MovimientoValidacionDocs(vm, datos) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/GuardaMovCalificacion`, datos).then(response => response.data);
    },
    ValidacionDocsEsc(vm, datos) {
        
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/GuardaValDocEsc`, datos).then(response => response.data);
    },
    EnviarCorreo(vm, datos) {
        
        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/EnviarCorreoAExterno`, datos).then(response => response.data);
    },
    ListaObs(vm, datos) {

        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/ListaObs`, datos).then(response => response.data);
    },
    
    AgregarMovRecepFis(vm, datos) {

        return vm.axios.post(`${vm.domain.domainNameForApi}Documentos/AgregarMovRecepFis`, datos).then(response => response.data);
    },
    RevisarStatus(vm, datos) {

        return vm.axios.post(`${vm.domain.domainNameForApi}SeguimientosReporte/RevisarStatus`, datos).then(response => response.data);
    }

};